<template>
  <com-page>
    <com-card>
      <div class="flex items-center justify-between">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="收益统计" name="income"></el-tab-pane>
          <el-tab-pane label="订单统计" name="order"></el-tab-pane>
        </el-tabs>
        <div>
          <el-date-picker
            v-model="date"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          <el-button type="primary" class="ml-15px" @click="search">搜索</el-button>
        </div>
      </div>
      <com-table
        ref="table"
        :api="api"
        :columns="columns"
        @on-sort="handleSort"
        :default-params="defaultParams"
      ></com-table>
    </com-card>
  </com-page>
</template>

<script>
import { storeStatistics, storeOrderStatistics } from '@/api/statistics'

export default {
  data() {
    return {
      api: storeStatistics,
      activeName: 'income',
      columns: [],
      incomeColumns: [
        {
          label: '网点名称',
          prop: 'storeName'
        },
        {
          label: '充值金额',
          prop: 'rechargeAmount',
          sortable: true
        },
        {
          label: '月卡金额',
          prop: 'monthCardAmount',
          sortable: true
        },
        {
          label: '总收益',
          prop: 'totalAmount',
          sortable: true
        }
      ],
      orderColumns: [
        {
          label: '网点名称',
          prop: 'storeName'
        },
        {
          label: '充值订单数',
          prop: 'rechargeOrder',
          sortable: 'custom'
        },
        {
          label: '月卡订单数',
          prop: 'monthCardOrder',
          sortable: 'custom'
        },
        {
          label: '充电订单数',
          prop: 'chargeOrder',
          sortable: 'custom'
        }
      ],
      date: [],
      query: {
        beginTime: '',
        endTime: ''
      },
      defaultParams: {}
    }
  },
  methods: {
    handleClick() {},
    search() {
      this.$refs.table.search(this.query)
    },
    handleSort(row) {
      const params = {
        orderBy: row.prop,
        sort: row.order === 'descending' ? 'desc' : 'asc'
      }
      this.defaultParams = { ...this.defaultParams, ...params }
      setTimeout(() => {
        this.$refs.table.init()
      }, 100)
    }
  },
  watch: {
    activeName: {
      handler(val) {
        if (val === 'income') {
          this.columns = this.incomeColumns
          this.api = storeStatistics
        } else {
          this.columns = this.orderColumns
          this.api = storeOrderStatistics
        }
        this.date = []
        this.defaultParams = {}
      },
      immediate: true
    },
    date: {
      handler(val) {
        if (val && val.length) {
          this.query.beginTime = val.at(0)
          this.query.endTime = val.at(1)
        } else {
          this.query.beginTime = ''
          this.query.endTime = ''
        }

        console.log('query :>> ', this.query)
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped></style>
